export const MSG_TOTAL = 'MSG_TOTAL'
export const MSG_SHOW = 'MSG_SHOW'
export const MSG_NOT_SHOW = 'MSG_NOT_SHOW'
export const MSG_GET_USER = 'MSG_GET_USER'
export const MSG_GET_ALL = 'MSG_GET_ALL'
export const MSG_SEND = 'MSG_SEND'
export const MSG_DEL_ID = 'MSG_DEL_ID'



// WEBPACK FOOTER //
// ./src/store/actions/messages.js